diy.angular.registerFactory('diyanimationframe', [function() {

    return function(duration, progressClb, finalClb) {
        var start = null, id, canceled = false;
        function step(timestamp) {
            if (canceled) {
                return;
            }
            var progress;
            if (start === null) start = timestamp;
            progress = Math.min(1, (timestamp - start) / duration);
            progressClb(progress);
            if (progress < 1) {
                id = requestAnimationFrame(step);
            } else {
                finalClb();
            }
        }
        id = requestAnimationFrame(step);
        return function(){
            canceled = true;
        }
    };
}]);


/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/angular/services/diyanimationframe.js
 ** module id = 933
 ** module chunks = 0
 **/